module.exports = __webpack_public_path__ + "img/saudia-7.53367210.png";